import script from "./CourseDetailView.vue?vue&type=script&lang=ts&setup=true"
export * from "./CourseDetailView.vue?vue&type=script&lang=ts&setup=true"

import "./CourseDetailView.vue?vue&type=style&index=0&id=3bdab0d8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3bdab0d8"]])

export default __exports__